"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/iot/user");
var _default = {
  props: ['editItem', 'roleList'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        id: 0,
        uid: 0,
        iot_deposit: 0,
        need_deposit: 0,
        score: 0
      },
      rules: {
        need_deposit: [{
          required: true,
          message: '请输入需调整的数量',
          trigger: 'change'
        }
        // { type: 'number', min: 0, message: '需付押金不能小于0', trigger: 'change' },
        ]
      }
    };
  },

  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      console.log(this.editItem);
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            (0, _user.getMemberScore)({
              uid: _this.editItem.id
            }).then(function (res) {
              _this.form.score = res.score;
            });
          }
        });
      } else {
        this.reset();
      }
    }
  },
  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _user.editMemberScore)({
            uid: _this2.editItem.id,
            score: _this2.form.need_deposit
          }).then(function (res) {
            if (res == '更新成功') {
              _this2.$message({
                message: res,
                type: 'success'
              });
              _this2.$emit('getList', true);
              _this2.dialogVisible = false;
            } else {
              _this2.$message({
                message: res,
                type: 'error'
              });
            }
          });
        } else {
          _this2.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;